<template>

    <div v-if="values.length>0" :class="class_" :style="advanced?'':'display:block'">
        <div :class="title_class">{{ $t("message.Size") }}</div>

        <div class="item-line" v-for="val in values">
            <label :class="label_class">
                <span class="checkbox">
                    <input type="checkbox" v-model="size[val.value]" @change="change_value(val.value)">
                    <span class="check"></span>
                </span>{{ $t("message.Size"+val.value) }}
            </label>
        </div>
    </div>
</template>

<script>
  import FilterSizeMix from "./FilterSizeMix";

  export default {
    name      : 'filter-size',
    props:{
      is_show: { type: Boolean, default: true },
      title_class: {type: String, default:'works-filter__block-title'},
      label_class: {type: String, default:''},
    },
    mixins: [FilterSizeMix],
  }
</script>



// WEBPACK FOOTER //
// src/components/list/filter/FilterSize.vue